exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".singlePhoto__imageCard___3Yxvb {\n  border-radius: 50%;\n  overflow: hidden; }\n  .singlePhoto__imageCard___3Yxvb + .singlePhoto__uploader___7swkP {\n    display: none; }\n\n.singlePhoto__uploader___7swkP {\n  border-radius: 50%; }\n", ""]);

// exports
exports.locals = {
	"imageCard": "singlePhoto__imageCard___3Yxvb",
	"uploader": "singlePhoto__uploader___7swkP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/PhotoUploader/SinglePhoto/singlePhoto.scss
// module id = 4880
// module chunks = 6